// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8570ae1d","582":"c10f1727","867":"4d7f122e"}[chunkId] + ".chunk.js";
};